<template>
  <div>
    <div id="billingMethods">
      <h1>{{ headerTitle }}</h1>
      <div class="steps-container">
        <ul class="steps-progressbar">
          <li class="step-active">select plan</li>
          <li class="step-active">select payment</li>
          <li>confirmation</li>
        </ul>
      </div>
      <div v-if="hasError" class="error center-element">
        Error: {{ errorMessage }}<br />
      </div>
      <div class="addMethodContainer form-300 center-element">
        <img
          src="../assets/payments.png"
          srcset="../assets/payments.png 1x, ../assets/payments.png 2x"
        />
        <label for="card">Credit Card Number</label><br />
        <div ref="cardNumber" class="card-style form-300" />
        <br />
        <label for="card">Expiration Date</label><br />
        <div ref="cardExpiry" class="card-style form-100" />
        <br />
        <label for="card">Security Code</label><br />
        <div ref="cardCvc" class="card-style form-100" />
      </div>
      <div class="center-text">
        <button
          tag="button"
          name="addCard"
          class="button button-200"
          @click="saveCard"
        >
          Save Credit Card</button
        ><br /><br />
        <button
          name="cancelAddCard"
          class="button-cancel button-100"
          @click="cancelCreate"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
const apiServiceBilling = new api.APIServiceBilling();

let stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
let elements = stripe.elements();
// let card = elements.create('card');
let cardNumber = elements.create("cardNumber");
let cardExpiry = elements.create("cardExpiry");
let cardCvc = elements.create("cardCvc");

export default {
  name: "AccountBillingCreateComponent",
  props: {
    headerTitle: {
      default: "Create a Payment Method",
      type: String
    }
  },
  data() {
    return {
      stripeError: false,
      errMessage: "",
      apiError: false
    };
  },
  computed: {
    hasError() {
      if (this.stripeError) {
        return true;
      }
      if (this.apiError) {
        return true;
      }
      return false;
    },
    errorMessage() {
      if (this.errMessage !== "") {
        return this.errMessage;
      }
      return "Error saving Credit Card";
    }
  },
  mounted: function() {
    var cardStyle = {
      base: {
        fontSize: "20px",
        lineHeight: "28px"
      }
    };
    // card.mount(this.$refs.card, {cardStyle});
    cardNumber.mount(this.$refs.cardNumber, { cardStyle });
    cardExpiry.mount(this.$refs.cardExpiry, { cardStyle });
    cardCvc.mount(this.$refs.cardCvc, { cardStyle });
  },
  methods: {
    saveCard: function() {
      stripe
        .createSource(cardNumber)
        .then(result => {
          // console.log(result);
          // update the api
          let cardAccount = {
            payment_method: result.source.card.brand,
            payment_exp_date:
              result.source.card.exp_month + "/" + result.source.card.exp_year,
            payment_last_4: result.source.card.last4,
            stripe_source_id: result.source.id
          };
          // console.log(cardAccount);
          apiServiceBilling
            .createAccountBillingMethod(cardAccount)
            .then(() => {
              this.$emit("card-created");
            })
            .catch(error => {
              this.apiError = true;
              this.errMessage = error;
            });
        })
        .catch(error => {
          this.stripeError = true;
          this.errMessage = error;
        });
    },
    cancelCreate: function() {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#billingMethods {
  lost-utility: clearfix;
}
.billingMethods {
  width: 100%;
  lost-column: 1/1;
}
.billingMethod {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
.addMethodContainer {
  margin-top: 40px;
}
.addMethodContainer img {
  margin-left: 20px;
  margin-bottom: 10px;
}
.steps-container {
  width: 600px;
  margin: 30px auto;
  padding-bottom: 60px;
}
.steps-progressbar {
  counter-reset: step;
}
.steps-progressbar li {
  list-style-type: none;
  width: 33%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
}
.steps-progressbar li:before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 30px;
  border: 2px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}
.steps-progressbar li:after {
  width: 100%;
  height: 2px;
  content: "";
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.steps-progressbar li:first-child:after {
  content: none;
}
.steps-progressbar li.step-active {
  color: #5584c0;
}
.steps-progressbar li.step-active:before {
  border-color: #5584c0;
}
.steps-progressbar li.step-active + li:after {
  background-color: #5584c0;
}
@media (max-width: 800px) {
  .billingMethod {
    lost-column: 1/2;
  }
  .steps-progressbar {
    width: 80%;
  }
}
@media (max-width: 640px) {
  .billingMethod {
    lost-column: 1/1;
  }
  .steps-progressbar {
    width: 90%;
  }
}
.card-style {
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 20px;
}
</style>
